module.exports = __webpack_public_path__ + "4893f01b632d3ee96982e87340b1d6f8.svg";